import Card from "./Card";

export const DataDisplayComponents = () => {
  return (
    <div className="my-4">
      <p>Data Display Components</p>
      <Card>
        <h1 className="text-display">hello</h1>
        <h2 className="text-heading-1">hello</h2>
        <h3 className="text-heading-2">hello</h3>
        <h4 className="text-heading-3">hello</h4>
        <h5 className="text-heading-4">hello</h5>
        <h6 className="text-heading-5">hello</h6>
        <h6 className="text-heading-6">hello</h6>

<p className="text-subtitle-1">Hello</p>
<p className="text-subtitle-2">Hello</p>
<p className="text-subtitle-3">Hello</p>
<p className="text-subtitle-4">Hello</p>
<p className="text-subtitle-5">Hello</p>
        
<p className="font-extrabold">Hello</p>
<p className="font-bold">Hello</p>
<p className="font-semibold">Hello</p>
<p className="font-regular">Hello</p>



      </Card>
    </div>
  );
};
